import React, { useRef, useState } from "react";
import styled from "styled-components";
import Event from "../../services/event";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";
import { useReactToPrint } from "react-to-print";
import { Dialog, DialogActions, DialogContent, Grid, MenuItem, Select } from "@material-ui/core";
import { ContainerBox } from "./styles";
import Label from "../../components/Label";
import { config } from "../../config";
import InputMask from "react-input-mask";
import { formatPhoneNumber, getFirstAndLastNames } from "../../utils/Functions";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
`;

const SearchBar = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
`;

const Input = styled.input`
    padding: 10px;
    width: 300px;
    margin-right: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
`;

const Button = styled.button`
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
        background-color: #0056b3;
    }
`;

const Results = styled.div`
    width: 100%;
    max-width: 600px;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 20px;
`;

const ResultItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #eee;

    &:last-child {
        border-bottom: none;
    }
`;

const Info = styled.div`
    flex: 1;
    font-size: 14px;

    p {
        margin: 5px 0;
    }
`;

const NoResults = styled.p`
    text-align: center;
    color: #999;
`;

const PaymentStatus = styled.span`
    color: ${(props) => (props.status === "Paga" ? "green" : "red")};
`;

const PrintButton = styled.button`
    padding: 8px;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 20px;

    &:hover {
        background-color: #218838;
    }

    &:disabled {
        background-color: #cccccc;
    }
`;

const EditButton = styled.button`
    padding: 8px;
    background-color: #ffc107;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 10px;

    &:hover {
        background-color: #e0a800;
    }

    &:disabled {
        background-color: #cccccc;
    }
`;

const Modal = styled.div`
    display: ${({ show }) => (show ? "flex" : "none")};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ModalHeader = styled.h3`
    margin-bottom: 20px;
`;

const ModalLabel = styled.label`
    align-self: flex-start;
    margin-bottom: 5px;
`;

const ModalInput = styled.input`
    padding: 10px;
    width: 100%;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
`;

const ModalButton = styled.button`
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
        background-color: #0056b3;
    }

    &:not(:last-child) {
        margin-right: 10px;
    }
`;

const eventRoles = [
    "Instrutor",
    "Expositor",
    "Staff",
    "Imprensa",
    "Patrocinador",
    "Apoio",
    "Internacional",
    "Participante",
    "VIP",
];

const FindCimiGuest = () => {
    const componentRef = useRef(null);
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [dialogPrintOpen, setDialogPrintOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [person, setPerson] = useState({});
    const [isModalOpen, setModalOpen] = useState(false);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const handleClosePrint = () => {
        setDialogPrintOpen(false);
    };

    const handleEditClick = (person) => {
        setPerson({ ...person, interage_id: person?.interage_id ? person?.interage_id : person?.name });
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
        // setPerson(null);
    };

    const handleSaveChanges = async () => {
        setIsLoading(true);
        try {
            const updatedPerson = await Event.updatePerson(person.id, {
                ...person,
                certificate: person.certificate ? 1 : 0,
                cpf: person?.cpf ? person?.cpf?.match(/\d/g)?.join("") : null,
                phone: person?.phone ? person?.phone?.match(/\d/g)?.join("") : null,
                email: person.email.toLowerCase(),
                category_id: 1,
                grade_id: 1,
                event_days_attended: person?.event_days_attended ? person.event_days_attended : ["*"],
                event_days_subscribed: ["*"],
            });

            if (updatedPerson && updatedPerson.data && updatedPerson.data.data) {
                toast.success("Alterado com sucesso!");

                const updatedPersonData = updatedPerson.data.data;
                const updatedResults = results.map((item) =>
                    item.id === updatedPersonData.id ? updatedPersonData : item
                );
                setResults(updatedResults);
                setPerson(updatedPersonData);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            setIsLoading(false);
            handleModalClose();
        }
    };

    function onChange(event) {
        const { value, name } = event.target;
        setPerson({ ...person, [name]: value });
    }

    const handleSelectRole = (event) => {
        const { value } = event.target;
        setPerson({
            ...person,
            role: value,
        });
    };

    function containsOnlyDigits(str) {
        return /^\d+$/.test(str);
    }

    const handleSearch = async () => {
        const cleanQuery = query.trim();

        if (!cleanQuery || cleanQuery.length <= 3) {
            toast.warn("Digite um valor válido");
            return;
        }

        let paramType = containsOnlyDigits(cleanQuery) ? "document" : "email";
        setIsLoading(true);

        try {
            const response = await Event.getPersonFromEduzzByDocOrEmail(1, { [paramType]: cleanQuery });
            if (response && response.data && response.data.data) {
                setResults(response.data.data);
            } else {
                toast.error("Desculpe, ocorreu um erro");
            }
        } catch (error) {
            console.error("Error fetching data", error);
            toast.error(error);
        } finally {
            setIsLoading(false);
            setQuery("");
        }
    };

    const updateCredential = async () => {
        if (person.credential_generated) return;

        setIsLoading(true);
        await Event.updatePerson(person.id, {
            ...person,
            credential_generated: true,
            event_days_attended: person?.event_days_attended
                ? person?.event_days_attended
                : [`${new Date().getDate()}`],
            event_days_subscribed: ["*"],
        });
        setIsLoading(false);
    };

    const printDialog = (
        <>
            <Dialog onClose={handleClosePrint} open={dialogPrintOpen}>
                <ContainerBox className="content">
                    <DialogContent style={{ minWidth: "400px", maxHeight: "400px" }}>
                        <Label size="medium" color="dark" align="left" weight="700" padding="5px 0">
                            Imprimir Tag para {person.name}
                        </Label>
                        <Grid container justify="space-around" spacing={2}>
                            <Grid id="teste" item md={12} style={{ width: "100%" }}>
                                <div
                                    ref={componentRef}
                                    id="to_pdf"
                                    className="card border-0"
                                    // style={{ width: "240px", height: "120px", border: "none" }}
                                    style={{ width: "280px", height: "110px", border: "none" }}
                                >
                                    <div
                                        className="row"
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            width: "100%",
                                            height: "100%",
                                        }}
                                    >
                                        <div className="col-sm-5">
                                            <div className="text-center">
                                                <img
                                                    src={`${config.QRCODE_HOST}/?size=105x105&data=${person.id}`}
                                                    alt={`${person.id}`}
                                                    className="card-img-top"
                                                    style={{
                                                        paddingTop: "2px",
                                                        paddingLeft: "2px",
                                                        paddingBottom: "2px",
                                                        paddingRight: "1px",
                                                        marginTop: "30px",
                                                        marginLeft: "4px",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="col-sm-7"
                                            style={{
                                                margin: "50px 0 2px 2px",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "20px",
                                                    fontWeight: "700",
                                                    textAlign: "center",
                                                    // textTransform: "capitalize",
                                                }}
                                                className="text-center name"
                                            >
                                                {person?.interage_id
                                                    ? person?.interage_id?.toUpperCase()
                                                    : getFirstAndLastNames(person?.name?.toUpperCase())}
                                            </div>
                                            {/* <div
                                                className="text-center info"
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: "700",
                                                    fontStyle: "normal",
                                                    textAlign: "justify",
                                                }}
                                            >
                                                <p className='role' style={{fontWeight: '600',textTransform:'capitalize'}}>{person.role}</p>
                                                <p
                                                    className="company"
                                                    style={{ fontSize: "14px", fontStyle: "italic" }}
                                                >
                                                    {person.role ? person.role.substring(0, 80) : null}
                                                </p>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={handleClosePrint} color="secondary">
                            cancelar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={async () => {
                                await updateCredential();
                                handlePrint();
                            }}
                            color="primary"
                        >
                            Imprimir
                        </Button>
                    </DialogActions>
                </ContainerBox>
            </Dialog>
        </>
    );

    return (
        <Container>
            {isLoading && <Loading />}
            {printDialog}
            <SearchBar>
                <Input
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Digite o email ou documento"
                />
                <Button onClick={handleSearch}>Buscar</Button>
            </SearchBar>

            <Results>
                {results.length === 0 ? (
                    <NoResults>Nenhum resultado encontrado</NoResults>
                ) : (
                    results.map((item) => (
                        <ResultItem key={item.id}>
                            <Info>
                                <p>
                                    <strong>Nome:</strong> {item.name}
                                </p>
                                <p>
                                    <strong>Documento:</strong> {item.cpf}
                                </p>
                                <p>
                                    <strong>Telefone:</strong> {formatPhoneNumber(item.phone)}
                                </p>
                                <p>
                                    <strong>Categoria:</strong> {item.role}
                                </p>
                                <p>
                                    <strong>Ingresso:</strong> {item.gender}
                                </p>
                                <p>
                                    <strong>Status do pagamento:</strong>{" "}
                                    <PaymentStatus status={item.rfid}>{item.rfid}</PaymentStatus>
                                </p>
                            </Info>
                            <div>
                                <PrintButton
                                    disabled={!item.id}
                                    onClick={() => {
                                        setPerson(item);
                                        setDialogPrintOpen({ dialogPrintOpen: true });
                                    }}
                                >
                                    {item.credential_generated ? "Reimprimir Tag" : "Imprimir Tag"}
                                </PrintButton>
                                <EditButton disabled={!item.id} onClick={() => handleEditClick(item)}>
                                    Editar
                                </EditButton>
                            </div>
                        </ResultItem>
                    ))
                )}
            </Results>

            {isModalOpen && person && (
                <Modal show={isModalOpen}>
                    <ModalContent>
                        <ModalHeader>Editar dados</ModalHeader>

                        <ModalLabel htmlFor="name">Nome:</ModalLabel>
                        <ModalInput
                            id="name"
                            type="text"
                            name="name"
                            value={person.name}
                            onChange={onChange}
                            placeholder="Nome"
                        />

                        <ModalLabel htmlFor="name">Nome Etiqueta:</ModalLabel>
                        <ModalInput
                            id="interage_id"
                            type="text"
                            name="interage_id"
                            value={person.interage_id}
                            onChange={onChange}
                            placeholder="Nome Etiqueta"
                        />

                        <ModalLabel htmlFor="cpf">Documento:</ModalLabel>
                        <ModalInput
                            id="cpf"
                            type="text"
                            name="cpf"
                            value={person.cpf}
                            onChange={onChange}
                            placeholder="Documento"
                        />

                        <ModalLabel htmlFor="phone">Telefone:</ModalLabel>
                        <InputMask
                            mask={
                                person.phone.startsWith("+")
                                    ? "+99 (99) 99999-9999"
                                    : person.phone.startsWith("55")
                                    ? "99 (99) 99999-9999"
                                    : "(99) 99999-9999"
                            }
                            name="phone"
                            value={person.phone}
                            onChange={onChange}
                        >
                            {(inputProps) => (
                                <ModalInput id="phone" type="text" placeholder="Telefone" {...inputProps} />
                            )}
                        </InputMask>

                        <ModalLabel htmlFor="phone">Categoria</ModalLabel>
                        <Select
                            placeholder="Categoria"
                            label="Categoria"
                            name="role"
                            fullWidth
                            value={person.role}
                            onChange={(e) => handleSelectRole(e)}
                        >
                            {eventRoles.map((item) => {
                                return <MenuItem value={item}>{item}</MenuItem>;
                            })}
                        </Select>

                        <div>
                            <ModalButton onClick={handleSaveChanges}>Salvar</ModalButton>
                            <ModalButton onClick={handleModalClose}>Cancelar</ModalButton>
                        </div>
                    </ModalContent>
                </Modal>
            )}
        </Container>
    );
};

export default FindCimiGuest;
